import BaseModal from 'plugins/modal/modal.js';
import tplImageModal from './templates/image.js';
import { __ } from 'i18n';
import { api } from '@converse/headless';
import { getFileName } from 'utils/html.js';
import { html } from 'lit';

import './styles/image.scss';

export default class ImageModal extends BaseModal {
    constructor(options) {
        super(options);
        this.src = options.src;
        this.is_expanded = false;
    }

    // Метод переключения масштаба
    toggleExpand = (e) => {
        if (e) {
            e.preventDefault();
            e.stopPropagation();
        }
        this.is_expanded = !this.is_expanded;

        // Используем e.target, чтобы найти родительское окно модалки
        // Мы поднимаемся от кнопки/картинки вверх до ближайшего .modal-dialog
        const target = e?.currentTarget || e?.target;
        const modalDialog = target?.closest('.modal-dialog') || this.querySelector('.modal-dialog');

        if (modalDialog) {
            if (this.is_expanded) {
                modalDialog.classList.add('modal-expanded');
            } else {
                modalDialog.classList.remove('modal-expanded');
            }
        }

        this.requestUpdate();
    };

    renderModal() {
        return tplImageModal({
            'src': this.src,
            'is_expanded': this.is_expanded,
            'toggleExpand': this.toggleExpand,
        });
    }

    getModalTitle() {
        return html`${__('Image ')}<a target="_blank" rel="noopener" href="${this.src}">${` `}</a>`;
    }
}

api.elements.define('converse-image-modal', ImageModal);
